import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eb3a377"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap_screen" }
const _hoisted_2 = { class: "status_bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 관리자에게 문의하기 ", -1))
const _hoisted_4 = { class: "wrap_chat_screen" }
const _hoisted_5 = { class: "form_box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "아이디", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "연락 받을 이메일", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "message" }, "문의 사항", -1))

import {
  ref,
  onMounted,
  onUnmounted,
  computed,
} from 'vue';
import { notification as AntNotification } from 'ant-design-vue/lib/components';
import type { SelectProps } from 'ant-design-vue';
import { Modal } from 'ant-design-vue';
import {
  iAvatar,
  iUserRoom,
} from '@interface/chat';
import {
  tabStore,
  userStore,
  tutorialStore,
} from '../stores/storeAuth';
import { pushPage } from '@utils/route.helper';
import router from '@router';
import { errorType } from '@interface/error';
import {
  postAvatar,
  requestGetAvatarList,
  getAvatarDetail,
  deleteAvatar,
  postAsk,
} from '@apis/voicechat';


export default /*#__PURE__*/_defineComponent({
  __name: 'AskAdmin',
  setup(__props) {

const userData = userStore();
const name = ref('');
const email = ref('');
const message = ref('');
const tabData = tabStore();
const showMobileMenu = () => {
  tabData.sideMenu = true;
};

const postAskAdmin = async () => {
  const params = {
    name: name.value,
    email: email.value,
    message: message.value,
  };
  if (!name.value.trim()) {
    AntNotification.error({ message: '이름을 넣어주세요!' });
    return;
  }
  if (!email.value.trim()) {
    AntNotification.error({ message: '받을 이메일 주소를 넣어주세요!' });
    return;
  }
  if (!message.value.trim()) {
    AntNotification.error({ message: '메시지를 넣어주세요!' });
    return;
  }
  try {
    const result = await postAsk(params);
    console.log(result);
    AntNotification.success({ message: '문의를 전송하였습니다.' });
    name.value = '';
    email.value = '';
    message.value = '';
  } catch (error: any) {
    AntNotification.error({ message: error?.message });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        class: "chevron",
        icon: "fa-solid fa-bars",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showMobileMenu()))
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("input", {
            name: "name",
            value: _unref(userData).userId ? _unref(userData).userId : '',
            disabled: ""
          }, null, 8, _hoisted_7),
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
            type: "email",
            name: "email"
          }, null, 512), [
            [_vModelText, email.value]
          ]),
          _hoisted_9,
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((message).value = $event)),
            name: "message"
          }, null, 512), [
            [_vModelText, message.value]
          ]),
          _createElementVNode("div", { class: "wrap_button" }, [
            _createElementVNode("div", {
              class: "button_okay",
              type: "submit",
              onClick: postAskAdmin
            }, " 문의하기 ")
          ])
        ])
      ])
    ])
  ]))
}
}

})